import script from "./StartApp.vue?vue&type=script&setup=true&lang=js"
export * from "./StartApp.vue?vue&type=script&setup=true&lang=js"

import "./StartApp.vue?vue&type=style&index=0&id=04b83cf8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04b83cf8"]])

export default __exports__